import { Tag, Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 * @param {Boolean} isAdmin
 */
export function createColumns(
  page = 1,
  showEditModal = null,
  showDeleteModal = null,
  isAdmin = false
) {
  const columnAcciones = isAdmin
    ? {
        title: "Acciones",
        key: "action",
        render: (record) => (
          <span>
            <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} />
            &nbsp;
            <Button icon={<DeleteOutlined />} onClick={() => showDeleteModal(record)} />
          </span>
        )
      }
    : {};

  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento - b.nrodocumento
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Celular",
      dataIndex: "nrocelular",
      key: "nrocelular",
      sorter: (a, b) => a.nrocelular.localeCompare(b.nrocelular),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Origen",
      dataIndex: "tipoorigen",
      key: "tipoorigen",
      render: (tipoorigen) => {
        let color = "";
        let text = "";
        switch (tipoorigen) {
          case "estudiante":
            color = "orange";
            text = "Estudiante";
            break;
          case "docente":
            color = "cyan";
            text = "Docente";
            break;
          case "administrativo":
            color = "lime";
            text = "Administrativo";
            break;
          default:
            break;
        }
        return (
          <Tag color={color} key={tipoorigen}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "Administrativo",
          value: "administrativo"
        },
        {
          text: "Estudiante",
          value: "estudiante"
        },
        {
          text: "Docente",
          value: "docente"
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.tipoorigen.indexOf(value) === 0,
      sorter: (a, b) => {
        return a.tipoorigen.length - b.tipoorigen.length;
      },
      sortDirections: ["descend", "ascend"]
    },
    columnAcciones
  ];
}
